/*
 * @Descripttion:
 * @version: v1.0
 * @Author: baidongsheng
 * @Date: 2021-09-17 17:24:01
 * @LastEditors: baidongsheng
 * @LastEditTime: 2021-09-23 11:42:12
 */
export default {
    youHave: 'You have',
    todoItems: 'new task',
    batchSuccess: 'workitem have been approved',
    batchFail: 'workitem have been unsuccessfully approved ',
    batchProcess: 'batch approve workitem ，please wait',
    failReason: 'Reason',
    batchWorkitemsLimit: 'Batch approval is limited to the 10 most recent tasks. <br /> Please reduce your selection, or only the first 10 tasks will be approved this time.',
    attachment: 'Attachment',
    signature: 'signature by hand',
    approveFail: 'do not pass approve',
    approveSuggestion: 'Approve Suggestion',
    transferInstructions: 'Transfer Instructions',
    noBatchWorkitemTip: 'todo items don\'t includes batch tasks,user can not toggle batch mode',
    unselectWorkitem: 'Please select batch approval task',
    timeOut: 'Timeout',
    goingTimeOut: 'later,it will timeout',
    timeoutLater: 'later,it will timeout',
    haveWaitFor: 'Waited For',
    days: 'Days',
    hours: 'Hours',
    minutes: 'Mins',
    lessOneMinute: 'less to 1 min',
    batch: 'Batch',
    batchApprove: 'Approve',
    batchTransfer: 'Batch Transfer',
    selectAll: 'Choose all',
    completed: 'Completed',
    haveSelected: 'Selected',
    markMultiRead: 'Mark to read',
    toreadItems: 'new read task',
    notSelectUnread: 'Please choose the unread item~',
    reciveTime: 'Recive Time',
    approvalTime: 'Approve Time',
    agree: 'Approve',
    reject: 'Reject',
    forward: 'Transfer',
    canceled: 'Cancel',
    canceled2: 'Cancelado',
    unresolved: 'Processing',
    readTime: 'Read Time',
    curActivity: 'Current Activities',
    stayTime: 'Stay Time',
    batchHandle: 'Batch Approval',
    cancelBatch: 'Cancel Batch',
    templateName: 'Workflow Template',
    flowItems: 'workfolw items',
    commonFlow: 'Commonly Use Workflow',
    haveSearch: 'Search for',
    items: ' results',
    historySearch: 'History search',
    beUrged: 'Urged',
    loadAllWorkflow: 'All processes loaded',
    usedTime: 'Used Time',
    usedTimeNew: 'Elapsed Time',
    costTime: 'Cost Time',
    finishTime: 'Finish Time',
    cancelTime: 'Cancel Time',
    resolveTime: 'Action Time',
    startTime: 'Start Time',
    completedTime: 'Completed Time',
    action: 'Action',
    'ok': 'OK',
};
